import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { UsersAPI } from '../api';
import { useAdmin } from '../lib/hooks';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const AdminApprove = () => {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('id');
  const navigate = useNavigate();
  const { isAdmin, loading: adminLoading } = useAdmin();
  
  const [status, setStatus] = useState<'idle' | 'processing' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleApprove = async () => {
    if (!requestId) return;
    
    setStatus('processing');
    try {
      const result = await UsersAPI.approveRequest(requestId);
      if (result.success) {
        setStatus('success');
        setMessage('Solicitud aprobada correctamente. El usuario ahora es administrador.');
      } else {
        setStatus('error');
        setMessage(result.error || 'Error al aprobar la solicitud.');
      }
    } catch {
      setStatus('error');
      setMessage('Error de conexión.');
    }
  };

  if (adminLoading) return <div className="flex justify-center p-10"><Loader2 className="animate-spin" /></div>;
  if (!isAdmin) return <div className="flex justify-center p-10 text-red-600">Acceso Denegado</div>;
  if (!requestId) return <div className="flex justify-center p-10">ID de solicitud inválido</div>;

  return (
    <div className="max-w-md mx-auto mt-20 mb-20 p-6 bg-white rounded-lg shadow-lg border text-center">
      <h2 className="text-2xl font-bold mb-4">Aprobar Administrador</h2>
      
      {status === 'idle' && (
        <div>
          <p className="mb-6 text-gray-600">Estás a punto de otorgar permisos de Administrador. ¿Confirmas esta acción?</p>
          <button 
            onClick={handleApprove}
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
          >
            Confirmar y Aprobar
          </button>
        </div>
      )}

      {status === 'processing' && (
        <div className="flex flex-col items-center">
          <Loader2 className="w-10 h-10 animate-spin text-blue-600 mb-2" />
          <p>Procesando...</p>
        </div>
      )}

      {status === 'success' && (
        <div className="flex flex-col items-center">
          <CheckCircle className="w-12 h-12 text-green-500 mb-2" />
          <p className="text-green-700 font-medium mb-4">{message}</p>
          <button 
            onClick={() => navigate('/admin/users')}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
          >
            Volver a Usuarios
          </button>
        </div>
      )}

      {status === 'error' && (
        <div className="flex flex-col items-center">
          <XCircle className="w-12 h-12 text-red-500 mb-2" />
          <p className="text-red-700 font-medium mb-4">{message}</p>
          <button 
            onClick={() => navigate('/admin/users')}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
          >
            Volver
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminApprove;
